import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-c5-five-one',
  templateUrl: './c5-five-one.component.html',
  styleUrls: ['./c5-five-one.component.scss']
})
export class C5FiveOneComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  showHeading = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 5){
      this.showSideMenu=true;
      this.fullWidth=false;
      this.showHeading = true;
    }
    else if(url.length === 6) {
      this.showSideMenu=false;
      this.fullWidth=true;
      this.showHeading = false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
      this.showHeading = false;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
